<ng-container *ngIf="kkm">
  <ng-container *ngFor="let item of kkmInfo">
    <div *ngIf="kkm[item.property] as value" class="ui-kit-layout-columns-2">
      <span [attr.data-qa]="'kkm-' + item.property + '-title'">{{ item.title | translate }}</span>
      <span [attr.data-qa]="'kkm-' + item.property">
        {{ value }}
        <ng-container *ngIf="item.property === 'fnsKkmId'">
          ({{ kkm.regStatusChangedAt | date: 'dd.MM.yy' }})
        </ng-container>
      </span>
    </div>
  </ng-container>
  <!--
  kkm.regStatus === 0,1,2 - Не зарегистрирована;
  kkm.regStatus === 3 - Ошибка регистрации в КГД;
  kkm.regStatus === 4 - Зарегистрирована в КГД;
  kkm.regStatus === 5 - Ошибка перерегистрации в КГД;
  kkm.regStatus === 6 - Ожидает снятие с учета в КГД;
  kkm.regStatus === 7 - Ошибка снятия с учета в КГД;
  kkm.regStatus === 8 - Снята с учета в КГД;
  kkm.regStatus === 9 - Списана/ Снята с учета;
  kkm.regStatus === 10 - Ожидает перерегистрацию в КГД;
  kkm.regStatus === 11 - Ожидает отключения от ОФД;
  kkm.regStatus === 13 - Ожидает перехода из другого ОФД;
  kkm.regStatus === 14 - Отключена от ОФД;
  kkm.regStatus === 15 - Ошибка отключения от ОФД;
  kkm.regStatus === 16 - Ошибка возвращения в ОФД;
  kkm.regStatus === 17 - Ошибка перехода в ОФД;
    ++-->
  <ng-container *ngFor="let item of kkmRegStatus">
    <div
      *ngIf="item.regStatus === kkm.regStatus"
      [class]="item.className"
      (click)="goToPage(item, kkm.id)"
      [attr.data-qa-link]="item.link ? 'reg-status-link-' + kkm.regStatus : null"
    >
      <span [attr.data-qa]="'reg-status-' + kkm.regStatus">
        {{ item.title | translate }}
        <ng-container *ngIf="item.showRegStatusChangedAt">{{
          kkm.regStatusChangedAt | dateTime
        }}</ng-container>
      </span>
    </div>
  </ng-container>
</ng-container>
